import {EMeasurementUnitAlias, MeasurementUnit} from "../Models/MeasurementUnit/MeasurementUnit";
import {ENumberValidationOption, validateNumber} from "@musicdata/common/src/Numbers/Validation";
import {AmountSpinnerRegister} from "./Register";

export function handleAmountSpinners() : void {
    let register = new AmountSpinnerRegister(document.getElementsByTagName("body")[0]);
    register.registerExistingAndWatchForNew();
    window.amountSpinnerRegister = register;
}

export class AmountSpinnerHandler {

    private readonly _spinnerElement : HTMLElement;
    private _subtractElement : HTMLButtonElement;
    private _addElement : HTMLButtonElement;
    private _inputElement : HTMLInputElement;

    private readonly _step : number;
    private readonly _measurementUnit : MeasurementUnit;
    private _value : number;

    private readonly _minimum : number;
    private readonly _maximum : number;

    public onMinimumReached : (minimum : number, measurementUnit : MeasurementUnit) => void;
    public onMaximumReached : (maximum : number, measurementUnit : MeasurementUnit) => void;

    public constructor(amountSpinnerElement : HTMLElement, measurementUnit : MeasurementUnit, step : number, minimum : number, maximum : number) {
        this._spinnerElement = amountSpinnerElement;
        this._subtractElement = null;
        this._addElement = null;
        this._inputElement = null;
        this._step = step;
        this._measurementUnit = measurementUnit;

        this._value = null;
        this._minimum = minimum;
        this._maximum = maximum;
    }

    public handle() : void {

        this.initialize();

        this.handleInputElement();
        // this.handleSubtractButton();
        // this.handleAddButton();
    }

    private initialize() : void {

        this._spinnerElement.querySelectorAll("button").forEach((buttonElement) => {

            if (buttonElement.classList.contains("minus")) {
                this._subtractElement = buttonElement;
                this.handleSubtractButton();

            } else if (buttonElement.classList.contains("plus")) {
                this._addElement = buttonElement;
                this.handleAddButton();
            }
        });

        this._inputElement = this._spinnerElement.querySelector<HTMLInputElement>("input.amount");

        let inputValue = this.inputValue;
        this.setValue(inputValue, false);
    }

    private handleSubtractButton() : void {

        this._subtractElement.addEventListener("click", () => {
            this.setValue(this._value - this._step, true);
        });
    }

    private handleAddButton() : void {

        this._addElement.addEventListener("click", () => {
            this.setValue(this._value + this._step, true);
        });
    }

    private handleInputElement() : void {

        this._inputElement.addEventListener("focusout", () => {
            this.setValue(this.inputValue, true);
        });
    }

    public triggerSubtractEvent() : void {
        let event = new MouseEvent("click");
        this._subtractElement.dispatchEvent(event);
    }

    public triggerAddEvent() : void {
        let event = new MouseEvent("click");
        this._addElement.dispatchEvent(event);
    }

    private setValue(value : number, userInteraction : boolean) : void {

        let validValue = this.determineClosestValidValue(value);

        if (value < this._minimum) {

            if (typeof this.onMinimumReached === "function" && userInteraction) {
                this.onMinimumReached(this._minimum, this._measurementUnit);
            }

            validValue = this._minimum;

        } else if (value > this._maximum) {

            if (typeof this.onMaximumReached === "function" && userInteraction) {
                this.onMaximumReached(this._maximum, this._measurementUnit);
            }

            validValue = this._maximum;
        }

        this._value = validValue;

        this._inputElement.type = "text";
        this._inputElement.value = this.formatValueForHuman(this._value) + " " + this._measurementUnit.text;
        this._inputElement.setAttribute("data-value", this._value.toString());
    }

    private formatValueForHuman(value : number) : string {

        let precision = 0;

        switch (this._measurementUnit.alias) {
            case EMeasurementUnitAlias.ks: precision = 0; break;
            case EMeasurementUnitAlias.l:
            case EMeasurementUnitAlias.m2:
            case EMeasurementUnitAlias.m3: precision = 4; break;
        }

        let fixedValue = value.toFixed(precision);

        let matchResult = fixedValue.match(/\.(0+[123456789]+|[123456789]*)(?<trailingZeros>0+)$/);

        if (matchResult !== null) {
            let trailingZerosLength = matchResult.groups["trailingZeros"].length;
            fixedValue = fixedValue.substring(0, fixedValue.length - trailingZerosLength);
        }

        return fixedValue
            .replace(".", ",")
            .replace(/,$/, "");
    }

    private determineClosestValidValue(value : number) : number {

        if (value < this._minimum) {
            value = this._minimum;
        }

        let times = value / this._step;
        times = parseInt((times).toFixed(10));

        if (times === 0) {
            return this._step;
        }

        return times * this._step;
    }

    private get inputValue() : number {

        let valueString = this._inputElement.value;

        valueString = valueString
            .toLowerCase()
            .replace(this._measurementUnit.text.toLowerCase(), "")
            .trim();

        let value = validateNumber(valueString, [ENumberValidationOption.forbidInfinity]);
        value = value ?? this._step;

        return value;
    }
}